import { S } from './state.js';
// ---- Particle palette + RNG ----
export const TYPES = {   // colors keyed by particle 'type' (used by spawnParticle)
  normal: { color: '#8fb6ff', glow: '#5e8bff' },
  gold:   { color: '#ffd66e', glow: '#ffb830' },
  bounce: { color: '#7dffb0', glow: '#23d27a' },
};

S.rngSeed = 1337;
// tiny deterministic-ish rng so a run feels coherent but varied
export function rnd() { S.rngSeed = (S.rngSeed * 1664525 + 1013904223) >>> 0; return S.rngSeed / 4294967296; }
export function rrange(a, b) { return a + (b - a) * rnd(); }
